export const DOCUMENT_UPLOAD_MAX_BYTES = 100 * 1024 * 1024

export const DOCUMENT_UPLOAD_MAX_FILES = 10

export const DOCUMENT_FILE_SIZE_EXCEEDED_MESSAGE = 'File size should not exceed 100MB'
